import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=2457c08a&"
import script from "./Menu.ts?vue&type=script&lang=ts&"
export * from "./Menu.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports